module.exports = __webpack_public_path__ + "b3ec3ccef448626ec8a245618a59a668.pdf";